import React, { Dispatch } from 'react';
import { Form } from 'react-bootstrap';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';

interface DateInputsProps {
	dateInputs: {
		name: string;
		label: string;
		value: string;
		default: string;
		set: Dispatch<React.SetStateAction<string>>;
	}[];
	start: string;
	end: string;
}

const DateInputs: React.FC<DateInputsProps> = ({ dateInputs, start, end }) => {
	return (
		<>
			{dateInputs.map((dateInput) => (
				<Form.Group key={dateInput.name} style={{ position: 'relative' }}>
					<Form.Label htmlFor={dateInput.name} style={{ marginBottom: '8px', marginTop: '12px' }}>
						{dateInput.label}
					</Form.Label>
					<Form.Control
						id={dateInput.name}
						name={dateInput.name}
						style={{
							width: '250px',
						}}
						type="date"
						value={dateInput.value}
						{...(dateInput.name === 'start' && end
							? {
									max: (() => {
										const maxDate = new Date(end);
										maxDate.setDate(maxDate.getDate() - 1);
										return format(maxDate, 'yyyy-MM-dd', { locale: it });
									})(),
								}
							: {})}
						{...(dateInput.name === 'end'
							? {
									min: (() => {
										if (!start) return;
										const minDate = new Date(start);
										minDate.setDate(minDate.getDate() + 1);
										return format(minDate, 'yyyy-MM-dd', { locale: it });
									})(),
								}
							: {})}
						onChange={(event) => {
							dateInput.set(event.target.value);
						}}
					/>
					{dateInput.value !== dateInput.default ? (
						<button
							type="button"
							className="btn-close"
							aria-label="Close"
							style={{
								boxSizing: 'border-box',
								width: '16px',
								height: '16px',
								backgroundSize: '8px 8px',
								opacity: '1',
								position: 'absolute',
								top: '56px',
								right: '44px',
							}}
							onClick={() => {
								dateInput.set(dateInput.default);
							}}
						/>
					) : null}
				</Form.Group>
			))}
		</>
	);
};

export default DateInputs;
